<template>
  <v-container class="text-center ma-0 pa-0 mt-7">
    <titleView width="100%" />
    <v-row>
      <v-col cols="12" class="text-center ma-0 pa-0 flickArea" ref="flickArea">
        <Flicking :options="{ circular: true }" ref="flick">
          <div class="flickdiv" v-if="$store.getters.dataFrameA">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%"
                height="100%" viewBox="0 0 368 368">
                <g>
                  <image width="368" height="368" xlink:href="/images/puzzle/base_a.png"></image>
                </g>

                <g transform="translate(207 207)">
                  <image ref="pieceA01" width="145" height="145" xlink:href="/images/puzzle/piece-a-01.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceA01') >= 0 ? '' : 'fitPuzzleDef'"></image>
                </g>
                <g transform="translate(240 127)">
                  <image ref="pieceA02" width="113" height="113" xlink:href="/images/puzzle/piece-a-02.png"
                    style="transform-origin: 57px 57px;"
                    :class="this.defaultViewPieceList.indexOf('pieceA02') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(15 127)">
                  <image ref="pieceA03" width="113.5" height="113.5" xlink:href="/images/puzzle/piece-a-03.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceA03') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(15 207.2)">
                  <image ref="pieceA04" width="145.5" height="145.5" xlink:href="/images/puzzle/piece-a-04.png"
                    style="transform-origin: 58px 58px;"
                    :class="this.defaultViewPieceList.indexOf('pieceA04') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
              </svg>
              <div class="frameName">{{ $store.getters.dataFrameA.name }}</div>
            </div>
          </div>
          <div class="flickdiv" v-if="$store.getters.dataFrameB">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%"
                height="100%" viewBox="0 0 368 368">
                <g>
                  <image width="368" height="368" xlink:href="/images/puzzle/base_b.png"></image>
                </g>
                <g transform="translate(13 13)">
                  <image ref="pieceB01" width="147" height="147" xlink:href="/images/puzzle/piece-b-01.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB01') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(127 13)">
                  <image ref="pieceB02" width="115" height="115" xlink:href="/images/puzzle/piece-b-02.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB02') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(208 13.2)">
                  <image ref="pieceB03" width="147" height="147" xlink:href="/images/puzzle/piece-b-03.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB03') >= 0 ? '' : 'fitPuzzleDef'"></image>
                </g>
                <g transform="translate(240 126.5)">
                  <image ref="pieceB04" width="115" height="115" xlink:href="/images/puzzle/piece-b-04.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB04') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(13.4 126.5)">
                  <image ref="pieceB05" width="115.2" height="115.2" xlink:href="/images/puzzle/piece-b-05.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB05') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(13 208)">
                  <image ref="pieceB06" width="147" height="147" xlink:href="/images/puzzle/piece-b-06.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB06') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(127 239.3)">
                  <image ref="pieceB07" width="115" height="115" xlink:href="/images/puzzle/piece-b-07.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB07') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
                <g transform="translate(208 208)">
                  <image ref="pieceB08" width="147" height="147" xlink:href="/images/puzzle/piece-b-08.png"
                    style="transform-origin: 74px 74px;"
                    :class="this.defaultViewPieceList.indexOf('pieceB08') >= 0 ? '' : 'fitPuzzleDef'">
                  </image>
                </g>
              </svg>
              <div class="frameName">{{ $store.getters.dataFrameB.name }}</div>
            </div>
          </div>
        </Flicking>

        <div id="flickNextBtn" class="flickBtnArea">
          <img src="/images/puzzle/btn_next.png" v-on:mousedown.prevent="flickNext"
            v-on:touchstart.prevent="flickNext" />
        </div>
        <div id="flickPrevBtn" class="flickBtnArea">
          <img src="/images/puzzle/btn_prev.png" v-on:mousedown.prevent="flickPrev"
            v-on:touchstart.prevent="flickPrev" />
        </div>
        <div id="flickIcon" class="flickBtnArea flickBtnIcon">
          <img src="/images/puzzle/flick_icon.png" />
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col cols="12" class="ma-0 pt-1 pb-1 pl-15 pr-15">
        <div v-on:mousedown="eventViewQrScan" v-on:touchstart="eventViewQrScan">
          <img src="/images/top/btn_qrscan.png" width="100%" />
        </div>
      </v-col>
      <v-col cols="12" class="ma-0 pt-1 pb-1 pl-15 pr-15">
        <div v-on:mousedown="eventViewShot" v-on:touchstart="eventViewShot" v-if="isShotOk">
          <img src="/images/top/btn_photo.png" width="100%" />
        </div>
        <div v-else>
          <img src="/images/top/btn_photo_off.png" width="100%" />
        </div>
      </v-col>
      <v-col cols="12" class="ma-0 pt-1 pb-1 pl-15 pr-15" v-if="isMapOk">
        <div v-on:mousedown="eventViewFloor" v-on:touchstart="eventViewFloor">
          <img src="/images/top/btn_floor.png" width="100%" />
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-12 pl-5 pr-5">
      <v-col cols="12" class="ma-0 pa-3">
        <div class="htpbase">
          <h2 class="htptitle">パズルラリーの遊び方1</h2>
          <div class="htptext">
          {{ $store.getters.dataHowtoplay1.text }}
          </div>
          <div class="htpimage pl-5 pr-3">
            <img :src="$store.getters.dataHowtoplay1.image" :style="'width: ' + ($store.getters.dataHowtoplay1.size ? $store.getters.dataHowtoplay1.size : '80%') + ';'" />
          </div>
        </div>
      </v-col>
      <v-col cols="12" class="ma-0 pa-3">
        <div class="htpbase">
          <h2 class="htptitle">パズルラリーの遊び方2</h2>
          <div class="htptext">
            パズルが完成したらフォトフレームが手に入るよ！「撮影する」ボタンを押して、ちびゴジラたちと写真を撮ろう！
          </div>
          <div class="htpimage pl-5 pr-5">
            <img src="/images/howtoplay/htp2.png" style="width: 90%" />
          </div>
        </div>
      </v-col>
      <v-col cols="12" class="ma-0 pa-3" v-if="$store.getters.dataHowtoplay3">
        <div class="htpbase">
          <h2 class="htptitle">パズルラリーの遊び方3</h2>
          <div class="htptext">
            {{ $store.getters.dataHowtoplay3.text }}
          </div>
          <div class="htpimage pl-2 pr-2">
            <img :src="$store.getters.dataHowtoplay3.image" style="width: 90%" />
          </div>
        </div>
      </v-col>
      <v-col cols="12" class="ma-0 pa-3" v-if="$store.getters.dataHowtoplay4">
        <div class="htpbase">
          <h2 class="htptitle">パズルラリーの遊び方4</h2>
          <div class="htptext">
            {{ $store.getters.dataHowtoplay4.text }}
          </div>
          <div class="htpimage ">
            <img :src="$store.getters.dataHowtoplay4.image" style="width: 90%" />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="mt-12">
      <v-col cols="12" class="ma-0 pa-3">
        <hr v-if="$store.getters.isMaintenance" />
        <ul class="attentionlist">
          <li v-on:click="maintenanceCheck(1)">●webブラウザ上で進行を保存しています。コンテンツ内でQRの読み取りやカメラ撮影を利用するため、カメラの利用は許諾をお願いします。</li>
          <li v-on:click="maintenanceCheck(1)">●本コンテンツご利用時のデータ通信量(パケット)はお客様負担となります。通信についての契約確認の上でご利用ください。</li>
          <li v-on:click="maintenanceCheck(2)">●OSのバージョンは最新版を推奨しております。iPadでは参加できない場合がございます。</li>
          <li v-on:click="maintenanceCheck(2)">●歩きながらのスマートフォンの使用は危険です。スマートフォン等の操作は周囲の安全を確認し、止まってご利用ください。</li>
        </ul>
      </v-col>
    </v-row>

    <v-row class="mt-12" v-if="$store.getters.isMaintenance">
      <v-col cols="12" class="ma-0 pt-1 pb-1 pl-15 pr-15">
        <div @click="eventMaintenance">
          メンテナンス
        </div>
      </v-col>
    </v-row>


    <v-row class="mt-12">
      <v-col cols="12" class="ma-0 pt-1 pb-1 pl-15 pr-15">
        <div v-on:mousedown="eventViewFloor" v-on:touchstart="eventViewFloor" v-if="isMapOk">
          <img src="/images/top/btn_floor.png" width="100%" />
        </div>
      </v-col>
    </v-row>


    <v-row class="mt-12">
      <v-col cols="12" class="ma-0 pa-3 mb-10 introText">
        <div>
          <h2>イントロダクション</h2>
          <p>
            ちびゴジラと仲間たちのゆるすぎる毎日を描くアニメ『ちびゴジラの逆襲』 ショートアニメとは思えない豪華すぎる声優陣と、クセ強すぎるちび怪獣たちが 忙しい現代人の毎日にくすっと笑える約3分をお届け！
            果たしてちびゴジラは父ゴジラのような「最強」の大怪獣になれるのか――！？
          </p>
        </div>
        <div>
          <h2>テレビ放送</h2>
          <p>
            毎週水曜あさ7:05 テレ東系列「おはスタ」番組内にて放送中！
          </p>
        </div>
        <div>
          <h2>配信</h2>
          <p>
            放送後、ちびゴジラ公式 YouTubeチャンネルにて全話無料配信中！
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-12">
      <v-col cols="12" class="ma-0 pt-5 pb-3 pl-15 pr-15" v-if="$store.getters.bannerData"
        @click="$store.getters.bannerData.url?goLink($store.getters.bannerData.url):null">
        <img :src="$store.getters.bannerData.image" width="100%" />
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12" class="text-center mt-6 pa-0">
        <span class="ma-0 pa-0" @click="goLink('https://x.com/chibigodzi')">
          <img src="/images/top/sns_x.png" class="snsicon" />
        </span>
        <span class="ma-0 pa-0" @click="goLink('https://www.instagram.com/chibigodzi_official/')">
          <img src="/images/top/sns_insta.png" class="snsicon" />
        </span>
        <span class="ma-0 pa-0" @click="goLink('https://www.youtube.com/@chibigodzi_official')">
          <img src="/images/top/sns_you.png" class="snsicon" />
        </span>
        <span class="ma-0 pa-0" @click="goLink('https://www.tiktok.com/@chibigodzi')">
          <img src="/images/top/sns_tik.png" class="snsicon" />
        </span>
      </v-col>
    </v-row>
    <v-row class="">

      <v-col cols="12" class="ma-0 pt-10 pb-5 pl-15 pr-15">
        <img src="/images/top/banner_chibi.png" width="80%" />
      </v-col>
    </v-row>


    <!-- -->

    <v-dialog v-model="dialogHowToPlay" max-width="400">
      <div class="dialogClose">
        <div v-on:mousedown.prevent="dialogHowToPlay = false" v-on:touchstart.prevent="dialogHowToPlay = false"><img
            src="/images/common/close.png" /></div>
      </div>
      <v-card class="dialogBase dialogMain">

        <v-card-text class="dialogHtpText">
          <Flicking :options="{ circular: true }" ref="dialogHtpFlick" @move-start="dialogHtpMoveStart"
            @move-end="dialogHtpMoveEnd">
            <div class="dialogFlickdiv">
              <v-row>
                <v-col cols="12" class="text-center htpcolbg" :style="dialogHtpCssBg1()">
                  <div class="dialogHtpTitle">パズルラリーの遊び方①</div>
                  <div class="text-left dialogHtpTextBody">
                    {{ $store.getters.dataHowtoplay1.text }}
                  </div>
                  <div class="htpcolimg"></div>
                </v-col>
              </v-row>
            </div>
            <div class="dialogFlickdiv">
              <v-row>
                <v-col cols="12" class="text-center htpcolbg"
                  style="background-image: url(/images/howtoplay/htp2.png);background-size: 70%;">
                  <div class="dialogHtpTitle">パズルラリーの遊び方②</div>
                  <div class="text-left dialogHtpTextBody">
                    パズルが完成したらフォトフレームが手に入るよ！「撮影する」ボタンを押して、ちびゴジラたちと写真を撮ろう！
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="dialogFlickdiv" v-if="$store.getters.dataHowtoplay3">
              <v-row>
                <v-col cols="12" class="text-center htpcolbg" :style="dialogHtpCssBg3()">
                  <div class="dialogHtpTitle">パズルラリーの遊び方③</div>
                  <div class="text-left dialogHtpTextBody">
                    {{ $store.getters.dataHowtoplay3.text }}
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="dialogFlickdiv" v-if="$store.getters.dataHowtoplay4">
              <v-row>
                <v-col cols="12" class="text-center htpcolbg" :style="dialogHtpCssBg4()">
                  <div class="dialogHtpTitle">パズルラリーの遊び方④</div>
                  <div class="text-left dialogHtpTextBody">
                    {{ $store.getters.dataHowtoplay4.text }}
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="dialogFlickdiv">
              <v-row>
                <v-col cols="12" class="text-center htpcolbg">
                  <div class="text-center htpattentiontitle">デジタルパズルラリーを<br />
                    お楽しみいただくにあたって</div>
                  <div class="text-left">
                    <ul class="htpattentionlist">
                      <li>●webブラウザ上で進行を保存しています。コンテンツ内でQRの読み取りやカメラ撮影を利用するため、カメラの利用は許諾をお願いします。</li>
                      <li>●本コンテンツご利用時のデータ通信量(パケット)はお客様負担となります。通信についての契約確認の上でご利用ください。</li>
                      <li>●OSのバージョンは最新版を推奨しております。iPadでは参加できない場合がございます。</li>
                      <li>●歩きながらのスマートフォンの使用は危険です。スマートフォン等の操作は周囲の安全を確認し、止まってご利用ください。</li>
                    </ul>
                  </div>
                </v-col>
              </v-row>
            </div>
          </Flicking>

          <v-row>
            <v-col cols="12" class="mb-2 mt-7 pa-0 htpdot">
              <v-row class="ma-0 pa-0">
                <v-col cols="12 text-center" ref="htpdotarea">
                  <a href="#" @click="dialogHtpGo(0)"><img src="/images/howtoplay/dot_red.png" ref="htdot1" /></a>
                  <a href="#" @click="dialogHtpGo(1)"><img src="/images/howtoplay/dot_gray.png" ref="htdot2" /></a>
                  <a href="#" @click="dialogHtpGo(2)"><img src="/images/howtoplay/dot_gray.png" ref="htdot3" /></a>
                  <a href="#" @click="dialogHtpGo(3)"><img src="/images/howtoplay/dot_gray.png" ref="htdot4" /></a>
                  <a href="#" @click="dialogHtpGo(4)"><img src="/images/howtoplay/dot_gray.png" ref="htdot5"
                      v-if="$store.getters.dataHowtoplay4" /></a>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTos" persistent max-width="400">
      <v-card class="dialogBase dialogMain">
        <v-card-title class="justify-center dialogTosTitle">※ご注意※
        </v-card-title>

        <v-card-text class="dialogTosText">
          <v-row>
            <v-col cols="12" class="mb-0 pb-0 pl-7 pr-6">
              <span style="color:red">開いているアプリによっては閉じてしまうと進行が保存されない場合があります。</span>
              <br />
              <span v-if="isSafari">右下に<img src="/images/tos/safari1.png" style="width: 3em;" />が表示される場合などは<img
                  src="/images/tos/safari2.png" style="width: 1em;" />をタップしてSafariに遷移しお楽しみください。</span>
              <span v-else>Chromeなどのブラウザで開いてお楽しみください。</span>


            </v-col>
            <v-col cols="12" class="mt-5 mb-0 pb-0 text-center">
              <div v-if="checkPermission">
                <span>動作環境を確認中</span>
              </div>
              <v-btn class="btn_blue" @click="permissionOk" v-if="!checkPermission">
                了解しました
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- GET -->
    <GetWindow v-if="getData != undefined" :data="getData" @close="dialogGetClose"></GetWindow>

    <!-- GET Same -->
    <GetSameWindow v-if="getSameData != undefined" :data="getSameData" @close="getSameData = undefined"></GetSameWindow>

    <!-- COMP -->
    <CompWindow v-if="compData != undefined" :data="compData" @close="dialogCompClose"></CompWindow>

    <!-- QR -->
    <QrWindow v-if="dialogQrScan" @close="dialogQrScan = false" @correct="eventReadQrData"></QrWindow>

    <!-- SHOT -->
    <ShotWindow v-if="dialogShot" @close="dialogShot = false"></ShotWindow>

    <!-- Floor -->
    <FloorWindow v-if="dialogFloor" @close="dialogFloor = false"></FloorWindow>
  </v-container>
</template>


<style scoped>
.frameName {
  font-family: "Noto Sans JP", sans-serif;
  font-weight: bold;
}

.htpcolbg {
  font-family: "M PLUS Rounded 1c", sans-serif;
  font-weight: 500;
  background-position: calc(50%) calc(100% - 5vw);
  background-repeat: no-repeat;
  margin: 0 !important;
  padding: 0 !important;
  height: min(110vw, 460px);
  font-size: min(4.2vw, 20px) !important;
  overflow: auto;
  line-height: 1.2em !important;
}

.htpdot img {
  width: min(3.5vw, 16px);
  margin-left: min(2vw, 8px);
  margin-right: min(2vw, 8px);
}

.htpattentiontitle {
  font-weight: 800;
  font-size: min(4vw, 18px);
  margin-top: min(4vw, 18px);
  padding-top: min(4vw, 18px);
  padding-bottom: min(6vw, 26px);
  margin-bottom: min(2vw, 9px);
  background-image: url(@/assets/images/htp_bar.png);
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 40%;
}

.htpattentionlist {
  padding: 0;
  margin: 0 auto;
}

.htpattentionlist li {
  font-size: min(3vw, 16px);
  font-weight: 500;
  list-style-type: none;
  text-align: left;
  padding: 1em 0 0 0;
  margin: 0 auto;
  line-height: 1.1rem !important;
}

.dialogTosTitle {
  font-weight: 800 !important;
  font-size: min(7vw, 32px) !important;
  margin-top: min(10vw, 32px);
  margin-bottom: min(10vw, 32px);
}


.dialogTosText {
  font-family: "M PLUS Rounded 1c", sans-serif;
  font-weight: 800 !important;
  font-size: min(4.5vw, 22px) !important;
  margin-top: min(10vw, 32px);
  margin-bottom: min(10vw, 32px);
  line-height: 1.4em;
}

.dialogFlickdiv {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding-top: min(3vw, 18px);
  padding-left: min(7vw, 42px);
  padding-right: min(7vw, 42px);
  font-size: min(5vw, 18px);
}

.dialogHtpTextBody {
  white-space: pre-line;
}


/* info */
.attentiontitle {
  font-size: min(5.5vw, 24px);
  font-weight: bold;
}

.attentionlist {
  width: min(72vw, 380px);
  padding: 0;
  margin: 0 auto;
}

.attentionlist li {
  font-size: min(3vw, 14px);
  font-weight: normal;
  list-style-type: none;
  text-align: left;
  padding: 0;
  margin: 4vw auto;
}

.htptitle {
  font-family: "M PLUS Rounded 1c", sans-serif;
  font-size: min(5vw, 24px);
  font-weight: 800;
  background-image: url(../static/images/title_bar.png);
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 2vw;
}

.htptext {
  font-family: "M PLUS Rounded 1c", sans-serif;
  background-color: white;
  font-size: min(4vw, 18px);
  border-radius: min(10vw, 24px);
  padding: min(7vw, 24px);
  padding-bottom: min(13vw, 64px);
  font-weight: 500;
  text-align: left;
}

.htpimage {
  position: relative;
  top: max(-8vw, -32px);
}


.flickArea {
  position: relative;
}

.flickBtnArea {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 1vw;
  padding-right: 1vw;
}

.flickBtnArea img {
  width: min(9vw, 32px);
  margin: min(1vw, 18px);
  z-index: 1;
}

.flickBtnIcon img {
  width: min(8vw, 48px) !important;
  margin-right: min(6vw, 30px);
}

#flickNextBtn {
  justify-content: flex-end;
  align-items: center;
}

#flickPrevBtn {
  justify-content: flex-start;
  align-items: center;
}

#flickIcon {
  justify-content: flex-end;
  align-items: end;
  margin-top: min(3vw, 15px);
}

.flickdiv {
  width: 100%;
  padding-top: min(3vw, 18px);
  padding-left: min(7vw, 42px);
  padding-right: min(7vw, 42px);
  font-size: min(5vw, 18px);
}

.fitPuzzle1 {
  opacity: 0;
  animation-name: fitAnime01;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.7s;
}

.fitPuzzle2 {
  opacity: 0;
  animation-name: fitAnime01;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

.fitPuzzleDef {
  opacity: 0;
}

@keyframes fitAnime01 {
  0% {
    opacity: 0;
    transform: translate(-50px, 20px) skewY(50deg) scaleZ(2) rotateX(45deg);
  }

  60% {
    opacity: 1;
  }

  100% {
    opacity: 1;
    transform: rotate(0) scale(1);
  }
}

.btn_blue {
  color: #FFFFFF !important;
  background-color: #0F9DE8 !important;
  box-shadow: 4px 3px #096291;
  border-radius: 100vh;
  width: 80%;
  height: 2.3em !important;
  padding-top: min(1vw, 3px) !important;
  font-size: min(5vw, 20px) !important;
  font-weight: 800 !important;
}

.btn_blue:disabled {
  box-shadow: 4px 3px #999999;
}

.introText {
  width: 100%;

}

.introText h2 {
  font-family: "M PLUS Rounded 1c", sans-serif;
  font-weight: 800;
  margin-top: min(10vw, 36px);
  font-size: min(4.5vw, 20px);
  color: #D7464D !important;
}

.introText p {
  padding: 0 1em 0 1em;
  font-size: min(4.5vw, 20px);
  font-weight: 500;
  margin-top: min(2vw, 10px);
  margin-bottom: min(2vw, 10px);
  text-align: left;
  margin-left: 0.7em;
  margin-right: 0.7em;
}

.snsicon {
  height: min(5.5vw, 30px);
  margin: 0 min(2vw, 10px);
  cursor: pointer;
}


.htptext {
  white-space: pre-line;
}
</style>
<script>
import '@/assets/style/window.css';

import TitleView from "./components/TitleView";
import QrWindow from "./components/QrWindow";
import GetWindow from "./components/GetWindow";
import GetSameWindow from "./components/GetSameWindow";
import ShotWindow from "./components/ShotWindow";
import FloorWindow from "./components/FloorWindow";
import CompWindow from "./components/CompWindow";

export default {
  name: "Top",
  data: () => ({
    dialogGoMission: false,
    checkPermission: false,
    liffError: false,
    liffProfile: null,
    maintenanceCount: 0,
    dialogTos: false,
    // dialogGet: false,
    dialogHowToPlay: false,
    dialogQrScan: false,
    dialogShot: false,
    dialogFloor: false,
    // getBgStyle: "",
    getData: undefined,
    compData: undefined,
    isShotOk: false,
    isMapOk: false,
    defaultViewPieceList: [],
    getSameData: undefined,
    isSafari: false,
  }),
  components: {
    TitleView,
    QrWindow,
    GetWindow,
    ShotWindow,
    FloorWindow,
    CompWindow,
    GetSameWindow
  },

  created: async function () {
    this.maintenanceCount = 0;
    this.isShotOk = this.isCheckShotOk();
    this.isMapOk = this.$store.getters.dataMaps ? true : false;

    // Safariの判定
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // this.$store.commit("setAllPiece", {
    //   "a": [true, true],
    //   "b": [true, true, true, false],
    //   "c": [true],
    // });

    // パズルデータの復元
    try {
      if (this.$store.getters.nowPiece.a[0]) {
        this.defaultViewPieceList.push("pieceA01", "pieceA02");
      }
      if (this.$store.getters.nowPiece.a[1]) {
        this.defaultViewPieceList.push("pieceA03", "pieceA04");
      }
      if (this.$store.getters.nowPiece.b[0]) {
        this.defaultViewPieceList.push("pieceB01", "pieceB02");
      }
      if (this.$store.getters.nowPiece.b[1]) {
        this.defaultViewPieceList.push("pieceB03", "pieceB04");
      }
      if (this.$store.getters.nowPiece.b[2]) {
        this.defaultViewPieceList.push("pieceB07", "pieceB08");
      }
      if (this.$store.getters.nowPiece.b[3]) {
        this.defaultViewPieceList.push("pieceB05", "pieceB06");
      }
    } catch (error) {
      console.log(error);
    }


    // 承認が得れてないのは初期表示という前提
    if (!this.$store.getters.isCheckTos) {
      this.dialogHowToPlay = true;
    } else {
      this.paramGetPiece();
      await this.$stamp.checkUseDevice();
    }


    // テスト

    // setTimeout(() => {
    // this.getData = { "frame": "b", "num": 1 };
    // this.getSameData = { "frame": "b", "num": 1 };
    // this.compData = { "frame": "b", "num": 1 };
    // }, 100);


    // this.dialogShot = true;

    // setTimeout(() => {
    //   this.$refs.flick.moveTo(1, 300);
    // }, 1000);
  },
  destroyed: function () {
  },
  methods: {
    paramGetPiece() {
      if (this.$store.getters.urlParamId) {
        let targetData;
        let sameData;
        const frameA = this.$store.getters.dataFrameA;
        const frameB = this.$store.getters.dataFrameB;
        const frameC = this.$store.getters.dataFrameC;
        if (frameA) {
          for (let i in frameA.qrs) {
            const params = new URLSearchParams(frameA.qrs[i]);
            if (params.get("id") == this.$store.getters.urlParamId) {
              if (this.$store.getters.nowPiece.a[i]) {
                sameData = { "frame": "a", "num": i };
              } else {
                targetData = { "frame": "a", "num": i };
              }
            }
          }
        }
        if (frameB) {
          for (let i in frameB.qrs) {
            const params = new URLSearchParams(frameB.qrs[i]);
            if (params.get("id") == this.$store.getters.urlParamId) {
              if (this.$store.getters.nowPiece.b[i]) {
                sameData = { "frame": "b", "num": i };
              } else {
                targetData = { "frame": "b", "num": i };

              }
            }
          }
        }
        if (frameC) {
          for (let i in frameC.qrs) {
            const params = new URLSearchParams(frameC.qrs[i]);
            if (params.get("id") == this.$store.getters.urlParamId) {
              if (this.$store.getters.nowPiece.c[i]) {
                sameData = { "frame": "c", "num": i };
              } else {
                targetData = { "frame": "c", "num": i };
              }
            }
          }
        }
        if (targetData) {
          this.getData = targetData;
        } else if (sameData) {
          this.getSameData = sameData;
        }
      }
    },
    dialogHtpCssBg1() {
      let size = "65%";
      if(this.$store.getters.dataHowtoplay1.size) size = this.$store.getters.dataHowtoplay1.size;
      return "background-image: url(" + this.$store.getters.dataHowtoplay1.image + ");background-size: " + size + " !important;"
    },
    dialogHtpCssBg3() {
      return "background-image: url(" + this.$store.getters.dataHowtoplay3.image + ");background-size: 90% !important;"
    },
    dialogHtpCssBg4() {
      let size = "90%";
      let position = " background-position: calc(45%) calc(100% - 10vw)  !important;";
      if(this.$store.getters.dataHowtoplay4.size) size = this.$store.getters.dataHowtoplay4.size;
      if(this.$store.getters.dataHowtoplay4.position==""){
        position = "";
      } else if (this.$store.getters.dataHowtoplay4.position) {
        position = " background-position: " + this.$store.getters.dataHowtoplay4.position + " !important;";
      }
      return "background-image: url(" + this.$store.getters.dataHowtoplay4.image + ");background-size: " + size + " !important;" + position ;
    },
    isCheckShotOk() {
      try {
        let nowPiece = this.$store.getters.nowPiece;
        let isOkA = true, isOkB = true, isOkC = true;
        for (let i in nowPiece.a) {
          if (!nowPiece.a[i]) {
            isOkA = false;
          }
        }
        for (let i in nowPiece.b) {
          if (!nowPiece.b[i]) {
            isOkB = false;
          }
        }
        for (let i in nowPiece.c) {
          if (!nowPiece.c[i]) {
            isOkC = false;
          }
        }
        return isOkA || isOkB || isOkC;
      } catch (error) {
        return false;
      }

    },
    eventReadQrData(data) {
      console.log("eventReadQrData", data);
      this.dialogQrScan = false;
      if (this.$store.getters.nowPiece[data.frame][data.num]) {
        this.getSameData = data;
      } else {
        this.getData = data;
      }
    },

    eventMaintenance() {
      this.$router.push({ name: 'maintenance', query: { "key": this.$store.getters.shopKey } });
    },
    flickNext() {
      // console.log("flickNext");
      this.$refs.flick.next();
    },
    flickPrev() {
      // console.log("flickPrev");
      this.$refs.flick.prev();
    },

    dialogAllReset() {
      this.compData = undefined;
      this.getData = undefined;
      this.getSameData = undefined;
    },
    dialogCompClose(data) {
      this.dialogAllReset();
      console.log("Frame COMP", data);
      this.eventViewShot();
    },

    dialogGetClose(data) {
      this.dialogAllReset();
      console.log("GET WIN CLOSE", data);
      const frameA = this.$store.getters.dataFrameA;
      const frameB = this.$store.getters.dataFrameB;
      const frameC = this.$store.getters.dataFrameC;
      const nowViewPuzzle = this.$refs.flick.index;

      let targetList = [];

      if (data.frame == "a" && frameA) {
        if (nowViewPuzzle != 0) {
          this.$refs.flick.moveTo(0);
        }
        switch (Number(data.num)) {
          case 0:
            targetList = ["pieceA01", "pieceA02"];
            break;
          case 1:
            targetList = ["pieceA03", "pieceA04"];
            break;
        }
      } else if (data.frame == "b" && frameB) {
        let targetNum = 1;
        if (!frameA) targetNum = 0;
        if (nowViewPuzzle != targetNum) {
          this.$refs.flick.moveTo(targetNum);
        }
        switch (Number(data.num)) {
          case 0:
            targetList = ["pieceB01", "pieceB02"];
            break;
          case 1:
            targetList = ["pieceB03", "pieceB04"];
            break;
          case 2:
            targetList = ["pieceB07", "pieceB08"];
            break;
          case 3:
            targetList = ["pieceB05", "pieceB06"];
            break;
        }
      } else if (data.frame == "c" && frameC) {
        this.$store.commit("setPiece", data);
        this.eventViewShot();
      }

      if (targetList.length == 2) {
        this.$store.commit("setPiece", data);
        this.$refs[targetList[0]].classList.add("fitPuzzle2");
        this.$refs[targetList[0]].classList.remove("fitPuzzleDef");
        this.$refs[targetList[1]].classList.add("fitPuzzle1");
        this.$refs[targetList[1]].classList.remove("fitPuzzleDef");
        window.scrollTo({
          top: this.$refs.flickArea.offsetTop,
          behavior: "smooth"
        });
        setTimeout(() => {
          this.$refs[targetList[0]].classList.remove("fitPuzzle2");
          this.$refs[targetList[1]].classList.remove("fitPuzzle1");

          let nowPiece = this.$store.getters.nowPiece;
          let isOk = true;
          if (data.frame == "a") {
            for (let i in nowPiece.a) {
              if (!nowPiece.a[i]) {
                isOk = false;
              }
            }
            if (isOk) {
              this.compData = { "frame": "a" };
              this.getData = undefined;
              this.getSameData = undefined;
              this.dialogQrScan = false;
              this.dialogShot = false;
              this.dialogFloor = false;
            }
          } else if (data.frame == "b") {
            for (let i in nowPiece.b) {
              if (!nowPiece.b[i]) {
                isOk = false;
              }
            }
            if (isOk) {
              this.compData = { "frame": "b" };
              this.getData = undefined;
              this.getSameData = undefined;
              this.dialogQrScan = false;
              this.dialogShot = false;
              this.dialogFloor = false;
            }
          }

        }, 2000);
      }

      this.isShotOk = this.isCheckShotOk();

    },

    dialogHtpMoveStart(e) {
      const targetArea = this.$refs.htpdotarea;
      let nowNum = e.currentTarget.index;
      let isforce = false;
      if (e.holding == true) {
        if (e.eventType == "moveStart") {
          if (e.direction == "NEXT") {
            nowNum++;
            if (nowNum >= targetArea.childNodes.length) {
              nowNum = 0;
            }
          } else {
            nowNum--;
            if (nowNum < 0) {
              nowNum = targetArea.childNodes.length - 1;
            }
          }
        }
      } else if (e.eventType == "forceMove") {
        nowNum = e.number;
        isforce = true;
      }
      if (nowNum != e.currentTarget.index || isforce) {
        for (let i = 0; i < targetArea.childNodes.length; i++) {
          if (targetArea.childNodes[i] && targetArea.childNodes[i].childNodes[0]) {
            const targetImage = targetArea.childNodes[i].childNodes[0];
            if (nowNum == i) {
              targetImage.src = "/images/howtoplay/dot_red.png";
            } else {
              targetImage.src = "/images/howtoplay/dot_gray.png";
            }
          }
        }
      }

    },
    dialogHtpMoveEnd(e) {
      setTimeout(() => {
        this.dialogHtpMoveStart({ "eventType": "forceMove", "number": e.currentTarget.index, "currentTarget": this.$refs.dialogHtpFlick })
      }, 100);
    },
    dialogHtpGo(num) {
      this.$refs.dialogHtpFlick.moveTo(num);
      this.dialogHtpMoveStart({ "eventType": "forceMove", "number": num, "currentTarget": this.$refs.dialogHtpFlick })
    },


    eventViewQrScan(e) {
      // console.log("eventViewQrScan");
      this.dialogAllReset();
      this.dialogQrScan = true;
      e.preventDefault();
      e.stopPropagation();
    },
    eventViewShot(e) {
      // console.log("eventViewShot");
      this.dialogAllReset();
      this.dialogShot = true;
      e.preventDefault();
      e.stopPropagation();
    },
    eventViewFloor(e) {
      // console.log("eventViewFloor");
      this.dialogAllReset();
      this.dialogFloor = true;
      e.preventDefault();
      e.stopPropagation();
    },

    goLink(url) {
      window.open(url, '_blank');
    },
    async permissionOk() {
      // this.$store.commit("checkDevice", true);
      this.$store.commit("setTos", true);

      try {
        this.checkPermission = true;
        try {
          await this.$stamp.checkUseDevice();
        } catch (error) {
          this.$router.push({ name: 'error', params: { 'errormessage': "カメラなどのデバイスの利用ができません。" } });
        }
        this.dialogTos = false;
        this.paramGetPiece();
        setTimeout(() => {
          this.checkPermission = false;
        }, 1000);
      } catch (e) {
        this.checkPermission = false;
        console.error(e);
      }
    },
    maintenanceCheck(num) {
      if (num == 0) {
        this.maintenanceCount = 0;
      } else if (num == 1 && this.maintenanceCount % 2 == 1) {
        this.maintenanceCount++;
      } else if (num == 2 && this.maintenanceCount % 2 == 0) {
        this.maintenanceCount++;
      } else {
        this.maintenanceCount = 0;
      }
      console.log(num, this.maintenanceCount, this.maintenanceCount % 4)
      if (this.maintenanceCount == 3) {
        console.log("maintenance mode on");
        this.$store.commit("setMaintenance", true);
        this.maintenanceCount = 0;
      }

    }
  },

  computed: {

    // nowMissionChapter() {
    //   return this.$store.getters.nowMissionChapter;
    // },
    // nowMissionSection() {
    //   return this.$store.getters.nowMissionSection;
    // },
    // nowMission() {
    //   return this.$store.getters.nowMissionChapter + "-" + this.$store.getters.nowMissionSection;
    // }
  },
  watch: {
    dialogHowToPlay: function (now, old) {
      if (!now && !this.$store.getters.isCheckTos) {
        this.dialogTos = true;
      }
    }
  }
};
</script>
